import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class ResourceBibleService {

    _headers: HttpHeaders;
    _bookid: any;
    _chapterid: any;

    constructor(
        private httpClient: HttpClient
    ) {
        this._headers = new HttpHeaders();
        this._headers = this._headers.append('api-key', 'ea1d558ae3ab1fa8bc7aed6e2145d489');
    }

    getBibles() {
        const url = 'https://api.scripture.api.bible/v1/bibles';
        return this.httpClient.get(url, {headers: this._headers});
    }

    getBooks(bibleId) {
        const url = 'https://api.scripture.api.bible/v1/bibles/' + bibleId + '/books';
        return this.httpClient.get(url, {headers: this._headers});
    }

    getChapters(bibleId, bookId) {
        this._bookid = bookId;
        const url = 'https://api.scripture.api.bible/v1/bibles/' + bibleId + '/books/' + this._bookid + '/chapters';
        return this.httpClient.get(url, {headers: this._headers});
    }

    getVerses(bibleId, chapterId) {
        this._chapterid = chapterId;
        const url = 'https://api.scripture.api.bible/v1/bibles/' + bibleId + '/chapters/' + this._chapterid + '/verses?content-type=text';
        return this.httpClient.get(url, {headers: this._headers});
    }

    getOneVerse(bibleId, verseId) {
        const url = 'https://api.scripture.api.bible/v1/bibles/' + bibleId + '/verses/' + verseId + '?content-type=text';
        return this.httpClient.get(url, {headers: this._headers});
    }

    getSearch(bibleId, keyword) {
        const url = 'https://api.scripture.api.bible/v1/bibles/' + bibleId + '/search?limit=100&query=' + keyword;
        return this.httpClient.get(url, {headers: this._headers});
    }

    getLandingPageStatus() {
        const url = 'https://witnesstoall.com/api/dailyCounters';
        return this.httpClient.get(url, {headers: this._headers});
    }
}
